import {NavigationPageType, NavigationTabType} from './navigations.enums';

//#region INTERFACE INavigate

/**
 * Represents the current navigation state of the application.
 *
 * This includes the active page and, if applicable, the active tab within that page.
 *
 * @interface INavigate
 */
export interface INavigate {
  /**
   * The currently active main page.
   *
   * This should correspond to a valid entry in the NavigationPage enum.
   *
   * @type {NavigationPageType}
   */
  currentPage: NavigationPageType;

  /**
   * The currently active tab within the current page, if any.
   *
   * This should correspond to a valid entry in the NavigationTab enum or be null if no tab is selected.
   *
   * @type {NavigationTabType | null}
   */
  currentTab: NavigationTabType | null;
}

//#endregion
